<template>
    <div class="l-body">
        <div class="l-menu-live" @click="taskEvent()">
            <div>直播指导表现</div>
        </div>
        <div class="l-red" v-if="isRead"></div>

    </div>
</template>
<script>
import TaskModel from './../models/task'
const taskModel = new TaskModel()
export default {
    name: "record",

    components: {

    },
    data() {
        return {
            taskFlag: false,
            isRead: false
        };
    },

    mounted() {
        this.handleGetList()
    },
    methods: {
        taskEvent() {
            this.$router.push({
                name: 'liveList'
            })

        },
        handleGetList() {
            taskModel.getLiveList().then(res => {
                this.listData = res.data;
                this.listData.forEach(element => {
                    if (element.showRead === 0) {
                        this.isRead = true;
                        return
                    }
                });
            })
        }
    },
};
</script>
<style lang="stylus" scoped>
@import "./css/index.styl";
</style>
